import React, { Fragment } from 'react';

import BundleItem from './bundle-item'
import { withError } from '../../../shared/components/error-boundary';
import Price from '../../../shared/components/price';
import { ModalControl } from '../../../context/modal/modal-context';
import { Helpers } from '../../../core/src/helpers';
import {MetricsElement} from 'react-metrics';
import '../../css/bundle-picker.less';

class BundlePicker extends React.Component {

    state={
        selectionMap:{},
        defaultSelected: false,
        disclaimer: null
    }

    componentDidMount() {
        this.preSelectBundles();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.priceMap !== this.props.priceMap) {
            this.preSelectBundles();
        }
    }

    preSelectBundles = () => {
        const { metaData={}, priceMap } = this.props;

        let defaultPreselected = false;
        let otherPreselected = false;
        let otherPreselectionIdx = -1;

        // loop through all other preselections and remember the last one
        this.props.bundles.forEach((bundle, idx) => {
            if (bundle.metadata.preselected) {
                otherPreselectionIdx = bundle.bundleIndex;
                otherPreselected = true;
            }
        });

        let newSelectionMap = this.getDefaultSelectionMap((newSelectionMap, bundle, idx) => {
            const isCheckboxPicker = !!metaData.checkbox;
            const isThisBundlePreselected = bundle.metadata.preselected

            const hasPricingInfo = (
                priceMap.hasOwnProperty(bundle.bundleIndex)
                && !!priceMap[bundle.bundleIndex]
            );
            const isPreselectable = (
                isThisBundlePreselected
                && (isCheckboxPicker || otherPreselected)
                && hasPricingInfo
            );

            if (bundle.bundleIndex === otherPreselectionIdx) {
                newSelectionMap[otherPreselectionIdx] = isPreselectable && isThisBundlePreselected;
            }
        })

        // if nothing is preselected, fallback to default bundle
        if (!defaultPreselected && !otherPreselected) {
            defaultPreselected = true;
        }

        this.handleChange(newSelectionMap, defaultPreselected);
    }

    /**
     * Generate selectionMap from scratch.
     * Map won't include status of default bundle option, only those that are fetched.
     */
    getDefaultSelectionMap = (modifier) => {
        const selectionMap = {};
        this.props.bundles.forEach((bundle, idx) => {
            selectionMap[bundle.bundleIndex] = false;

            if (modifier) {
                modifier(selectionMap, bundle, idx);
            }
        });
        return selectionMap;
    }

    handleChange = (selectionMap, defaultSelected) => {
        this.setState({ selectionMap, defaultSelected }, () => {
            this.updateSelectedBundles(selectionMap);
        });
    }

    /**
     * Handler for a regular bundle option
     */
    handleClick = (bundleIndex) => {
        let defaultSelected = true;
        const { metaData } = this.props;

        // metaData.checkbox - if its true, user can select multiple items, if false - only one
        const newSelectionMap = metaData.checkbox
            ? Object.assign({}, this.state.selectionMap)
            : this.getDefaultSelectionMap();
        newSelectionMap[bundleIndex] = !this.state.selectionMap[bundleIndex];

        // cannot unselect bundle if !checkbox
        if (!newSelectionMap[bundleIndex] && !metaData.checkbox){
            return;
        }
        // unselecting default options if no lockDefault and no checkbox
        if (newSelectionMap[bundleIndex] && !metaData.lockDefault && !metaData.checkbox) {
            defaultSelected = false;
        }

        this.handleChange(newSelectionMap, defaultSelected);
    }

    /**
     * Handler for default bundle option
     */
    handleDefaultClick = () => {
        const { metaData } = this.props;
        const defaultSelected = !this.state.defaultSelected;

        // cannot unselect default option if lockDefault or no checkbox
        if(metaData.lockDefault || !defaultSelected) return;
        if(!metaData.checkbox){
            // unselecting the other selected bundle if no checkbox
            let selectionMap = this.getDefaultSelectionMap();
            this.handleChange(selectionMap, defaultSelected);
        }
    }

    //sending a new array of Bundles(addOns)
    updateSelectedBundles = (selectionMap) => {
        let selectedBundles = this.props.bundles.reduce((selectedBundles, bundle)=>{
            if(this.state.selectionMap[bundle.bundleIndex]){
                selectedBundles.push(...bundle.products);
            }
            return selectedBundles;
        },[]);
        if(selectedBundles.length === 0) selectedBundles = null;
        const totalPrice = this.props.calculateTotalPrice(selectionMap);
        //only update price when prices are available
        if(Object.keys(totalPrice).length > 0){
            this.props.onChange(selectedBundles, totalPrice);
        }
    }

    getTotalProductPrice = (priceMap, bundle, upsell) => {
        let totalProductPrice = {};
        if(!priceMap[bundle.bundleIndex]){
            return totalProductPrice;
        }
        if(!upsell){
            totalProductPrice.regularPrice = priceMap.default.regularPrice + priceMap[bundle.bundleIndex].regularPrice;
            totalProductPrice.salePrice = priceMap.default.salePrice + priceMap[bundle.bundleIndex].salePrice;
        }else{
            totalProductPrice.regularPrice = priceMap[bundle.bundleIndex].regularPrice;
            totalProductPrice.salePrice = priceMap[bundle.bundleIndex].salePrice;
        }
        return totalProductPrice;
    }

    getMetrics = (bundle) => {
        try{
            let {metricsId} = this.props;
            let {products} = bundle || {};
            let [product] = products || [];
            let linkIdSuffix = (product && product.sku) || 'default';
            return {
                element: 'span',
                'data-metrics-event-name': 'linkClick',
                'data-metrics-event': 'e_linkClick',
                'data-metrics-link-id': `${metricsId}-modify-${linkIdSuffix}`,
                'data-metrics-link-placement': 'product'
            }
        }catch(e){}

        return {};
    }

    render(){
        const { bundles=[], metaData={}, priceMap, CustomItemComponent, children, enableMetrics } = this.props;
        const { defaultOption, template, upsell=true } = metaData;
        const { selectionMap, defaultSelected, disclaimer } = this.state;
        return(
            <ModalControl
                content={()=><div dangerouslySetInnerHTML={Helpers.createMarkup(disclaimer)}></div>}
                contentProps={{}}
                modalProps={{className: 'bundle-disclaimer-modal'}}
            >
                {(props) =>{

                    const handleOpenModal = (disclaimer) => {
                        this.setState({disclaimer}, ()=>props.openModal())
                    }

                    const defaultPriceProps = {
                        price: priceMap.default,
                        spClassName: 'sale-price',
                        showListPrice: priceMap.default.regularPrice !== priceMap.default.salePrice,
                        showSalePrice: true
                    };
                    const defaultProductPrice = <div className='prd-price'><Price  {...defaultPriceProps} /></div>;
                    const defaultOptionProps = {
                        className:'default-option',
                        bundle:{metadata: {optionName: defaultOption}},
                        selected: defaultSelected,
                        onClick:this.handleDefaultClick,
                        showProductPrice: true,
                        openModal:handleOpenModal,
                        productPrice: defaultProductPrice,
                        template
                    };

                    const defaultBundleOption = CustomItemComponent
                                                ? <CustomItemComponent {...defaultOptionProps} /> 
                                                : <BundleItem {...defaultOptionProps}/>;
                    return(
                        <Fragment>
                            {children && children({
                                handleClick: this.handleClick,
                                handleDefaultClick: this.handleDefaultClick,
                                bundles,
                                ...this.state
                            })}
                            <div className='bundle-options'>
                                {/* Default bundle option */}
                                {
                                    enableMetrics
                                    ? <MetricsElement {...this.getMetrics()}>{defaultBundleOption}</MetricsElement>
                                    : defaultBundleOption
                                }
                                {/* Fetched bundle options */}
                                {
                                    bundles.map((bundle, i) => {
                                        // block the item from showing if priceMap has no record abt this bundle
                                        let totalProductPrice = this.getTotalProductPrice(priceMap, bundle, upsell);
                                        const priceProps = {
                                            price: totalProductPrice,
                                            spClassName: 'sale-price',
                                            showListPrice: totalProductPrice && totalProductPrice.regularPrice !== totalProductPrice.salePrice,
                                            showSalePrice: true
                                        };
                                        let productPrice = <div className='addon-prd prd-price'><Price  {...priceProps}/></div>;
                                        const bundleItemProps = {
                                            key:i,
                                            selected:selectionMap[bundle.bundleIndex],
                                            onClick:this.handleClick,
                                            showProductPrice:true,
                                            openModal:handleOpenModal,
                                            productPrice,
                                            template,
                                            bundle
                                        };

                                        let item = CustomItemComponent
                                            ? <CustomItemComponent {...bundleItemProps} />
                                            : <BundleItem {...bundleItemProps}/>;

                                        return (
                                            enableMetrics
                                            ? <MetricsElement {...this.getMetrics(bundle)}>{item}</MetricsElement>
                                            : item
                                        );
                                    })
                                }
                            </div>
                        </Fragment>
                    )
                }}
            </ModalControl>
        );
    }
}

BundlePicker.defaultProps = {
    metricsId: 'bundle'
}

export default withError(BundlePicker);
